<!--
 * @Author: mzw
 * @Date: 2025-04-22 14:22:05
 * @LastEditTime: 2025-04-22 14:22:05
 * @LastEditors: mzw
 * @Description: 物料助手-导出模板选择
-->
<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="历史记录"
    :close-on-click-modal="true"
    :before-close="handleClose"
    width="1000px"
  >
    <Search
      ref="search"
      :searchConfig="searchConfig"
      @doSearch="doSearch"
    >
    </Search>
    <Table
      ref="table"
      :tableConfig="tableConfig"
    >
      <template :slot="'statusIn'" slot-scope="{ row }">
        {{ row.status | getStatus }}
      </template>
      <template :slot="'downloadUrl'" slot-scope="{ row }">
        <el-button
          type="text"
          link
          v-if="row.status === '3'"
          @click="submitTask(row)"
        >重试</el-button>
        <el-button
          type="text"
          link
          @click="viewDetail(row)"
        >详情</el-button>
      </template>
    </Table>
  </el-dialog>
</template>

<script>
import Search from '@/components/search/index';
import Table from '@/components/table/index';
const options = [
  {
    value: "等待中",
    code: "0"
  },
  {
    value: "进行中",
    code: "1"
  },
  {
    value: "成功",
    code: "2"
  },
  {
    value: "失败",
    code: "3"
  }
];
export default {
  name: 'MaterialRecords',
  components: {
    Search,
    Table
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isMineData: {
      type: Boolean
    }
  },
  data () {
    return {
      dialogVisible: false,
      searchConfig: {
        params: [
          {
            prop: 'demandName',
            label: '需求名称'
          },
          {
            prop: "statusList",
            label: '任务状态',
            placeholder: "任务状态",
            searchType: "multipleSelect",
            props: {
              label: "value",
              value: "code"
            },
            options: options,
            searchValueType: "array"
          }
        ]
      },
      tableConfig: {
        searchUrl: '/help/ai/user/materialAssistant/listByPage', // 搜索接口
        searchMethod: 'POST', // 接口请求方式
        needPagination: true, // 是否需要分页
        // extra: {},
        autoSearch: false,
        // fluidHeight: true, // 流体高度
        showOrdinal: true,
        resultListName: 'dataList',
        params: [
          {
            prop: "demandName",
            label: "需求名称",
            minwidth: "200"
          },
          {
            prop: "statusIn",
            label: "状态",
            isSlot: true,
            width: "120"
          },
          {
            prop: "createUserName",
            label: "创建人",
            width: "150"
          },
          {
            prop: "createTime",
            label: "创建时间",
            columnsType: "date"
          },
          {
            prop: "downloadUrl",
            label: "操作",
            isSlot: true,
            width: "100",
            fixed: "right"
          }
        ]
      },
    }
  },
  filters: {
    getStatus(val) {
      let str = "";
      options.some(v => {
        if (v.code === val) {
          str = v.value;
          return true;
        }
        return false;
      });
      return str || val;
    }
  },
  methods: {
    init() {
      this.dialogVisible = true;
      this.$nextTick(()=>{
        this.$refs.search.reset(true)
        // this.doSearch()
      })
    },
    doSearch(val={}) {
      this.tableConfig.extra = {
        ...val,
        createUserId: this.isMineData ? this.$store.state.user.userId: null
      }
      this.$refs.table.getList();
    },
    handleClose() {
      // this.$refs.table.clearSelection();
      this.dialogVisible = false;
    },
    submitTask(row) {
      this.$http
        .post(`/help/ai/user/materialAssistant/retry?taskId=${row.taskId}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.$message.success('已提交重试，请等待系统处理。')
          this.doSearch()
        })
    },
    viewDetail(row) {
      this.handleClose()
      console.log(row.taskNo)
      this.$emit('reload', {taskNo: row.taskNo})
    }
  }
}
</script>

<style lang='scss' scoped>
.warn {
  color: #f56c6c;
}
</style>